// Page-specific content (programs detail, etc.)
import { PHOTOS } from "./photos";

export const PROGRAMS = [
  {
    slug: "rss",
    title: "Recovery Support Services (RSS)",
    short: "In-center peer support and recovery community programming.",
    intro:
      "Recovery Support Services take place in our Recovery Community Centers in Orange, Seminole, Brevard and Osceola counties. Each center is a welcoming place to find connection, accountability and momentum.",
    image: PHOTOS.groupTherapy,
    icon: "Home",
    highlights: [
      "All-recovery meetings led by Certified Recovery Peer Specialists",
      "One-on-one peer coaching and recovery planning",
      "Family support sessions and education",
      "Life-skills, employment, and reintegration workshops",
      "Sober social activities and community events",
    ],
    process: [
      { step: "01", title: "Reach Out", body: "Call our helpline or stop by a center. No paperwork to start." },
      { step: "02", title: "Meet a Peer Specialist", body: "Connect with someone who has lived experience similar to yours." },
      { step: "03", title: "Build Your Plan", body: "You direct your recovery; we walk alongside." },
      { step: "04", title: "Stay Connected", body: "Lifetime community — keep showing up, keep growing." },
    ],
  },
  {
    slug: "mobile-rss",
    title: "Mobile RSS",
    short: "Meeting people where they are — in neighborhoods, hospitals, and beyond.",
    intro:
      "Our Mobile Recovery Support Services break down barriers by bringing peer support directly to where people are. From hospital bedside visits to neighborhood pop-ups, our team meets you where you are — not the other way around.",
    image: PHOTOS.conversation,
    icon: "Bus",
    highlights: [
      "Bedside peer visits at partner hospitals and ERs",
      "Mobile outreach in underserved neighborhoods",
      "On-site support at events, shelters and community partners",
      "Warm hand-offs to long-term recovery resources",
      "Same-day follow-up and ongoing connection",
    ],
    process: [
      { step: "01", title: "We Show Up", body: "Our mobile team responds to community partners and outreach calls." },
      { step: "02", title: "Meet & Listen", body: "A peer specialist sits with you — no pressure, no script." },
      { step: "03", title: "Connect to Resources", body: "From treatment to housing to recovery meetings." },
      { step: "04", title: "Keep In Touch", body: "Mobile RSS stays with you through the early, fragile days." },
    ],
  },
  {
    slug: "justice-rss",
    title: "Justice Involved RSS",
    short: "Court-connected peer support inside the Ninth Judicial Circuit.",
    intro:
      "Our Certified Recovery Peer Specialists work alongside participants in the Ninth Judicial Circuit Court Problem Solving Court — helping people in the justice system find pathways to long-term recovery and stable reintegration.",
    image: PHOTOS.therapy3,
    icon: "Scale",
    highlights: [
      "Peer specialists embedded with Problem Solving Court teams",
      "Re-entry planning and recovery navigation",
      "Connections to housing, employment, and behavioral health care",
      "Family support and reunification resources",
      "Long-term mentoring beyond court completion",
    ],
    process: [
      { step: "01", title: "Court Connection", body: "Referrals come through Problem Solving Court teams and partners." },
      { step: "02", title: "Lived-Experience Match", body: "You’re paired with a peer who has navigated similar terrain." },
      { step: "03", title: "Build a Recovery Plan", body: "We help align court requirements with your long-term goals." },
      { step: "04", title: "Beyond the Court", body: "Support continues long after the case closes." },
    ],
  },
];

export const IMPACT_STATS = [
  { value: "1,200+", label: "Individuals served annually" },
  { value: "4", label: "County community centers" },
  { value: "40+", label: "Peer specialists statewide" },
  { value: "10,000+", label: "Hours of peer support delivered" },
  { value: "24/7", label: "Helpline coverage" },
  { value: "$0", label: "Cost to participants" },
];

export const IMPACT_HIGHLIGHTS = [
  {
    title: "Community Centers Across Central Florida",
    body: "Welcoming, recovery-friendly spaces in Orange, Seminole, Brevard, and Osceola counties.",
    icon: "MapPin",
  },
  {
    title: "Hospital & Mobile Outreach",
    body: "Bedside peer visits, mobile pop-ups, and warm hand-offs that close the gap between crisis and care.",
    icon: "Activity",
  },
  {
    title: "Court & Re-entry Support",
    body: "Embedded peer specialists in Problem Solving Court — helping people rebuild lives after justice involvement.",
    icon: "Scale",
  },
  {
    title: "Workforce & Training",
    body: "We train and credential the next generation of Certified Recovery Peer Specialists across Florida.",
    icon: "GraduationCap",
  },
];

export const WAYS_TO_HELP = [
  {
    id: "donate",
    title: "Donate",
    body: "Every gift fuels peer specialists, training, and outreach — directly powering recovery in Central Florida.",
    cta: { label: "Donate Now", href: "/donate" },
    icon: "HeartHandshake",
  },
  {
    id: "volunteer",
    title: "Volunteer",
    body: "Share your time, talent and lived experience. From event support to peer mentorship, there is a role that fits you.",
    cta: { label: "Volunteer With Us", href: "/contact" },
    icon: "Hand",
  },
  {
    id: "partners",
    title: "Partner With Us",
    body: "Healthcare systems, courts, employers and community organizations — partner to expand peer recovery support.",
    cta: { label: "Start a Conversation", href: "/contact" },
    icon: "Handshake",
  },
  {
    id: "advocate",
    title: "Advocate",
    body: "Lend your voice to end stigma, change policy, and elevate the recovery movement in Central Florida and beyond.",
    cta: { label: "Get Involved", href: "/contact" },
    icon: "Megaphone",
  },
];

export const RESOURCES = [
  { title: "24/7 Helpline", body: "Speak to a Certified Recovery Peer Specialist any time.", href: "tel:+14077326837", linkLabel: "Call 407.RECOVER" },
  { title: "Find a Community Center", body: "Drop-in centers in Orange, Seminole, Brevard, and Osceola counties.", href: "/programs/rss", linkLabel: "View Centers" },
  { title: "Mobile RSS Outreach", body: "Peer specialists who come to you — hospitals, neighborhoods, partner sites.", href: "/programs/mobile-rss", linkLabel: "How it Works" },
  { title: "Family & Loved Ones", body: "Education, support and recovery-informed guidance for families.", href: "/need-help#families", linkLabel: "Family Resources" },
];

export const DONATION_AMOUNTS = [25, 50, 100, 250, 500, 1000];
